export default "__VITE_ASSET__BymLuM2R__"